import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import IconToolTip from '../../../common/IconToolTip';



export default function ViewAllModal(props) {
  const { data, homeCity, workedOnCity } = props
  const [allData, setAllData] = useState(data);
  let workedOnCitySet = new Set(workedOnCity)
  const boxStyle = {
    border: 0,
    p: 1,
    height: '40em',
    width: '60em',
    bgcolor: 'white',
  };


  const handleSearch = (e) => {
    let searchKey = e.target.value.trim().toLowerCase();
    if (searchKey === '') {
      setAllData(data)
      return
    }
    const valueListWithSearchTerm = allData.filter(value =>
      value.toLowerCase().includes(searchKey)
    );
    setAllData(valueListWithSearchTerm);

  };


  return <>
    <Box sx={boxStyle} className='shadow-2xl overflow-auto'>
      <input
        onChange={handleSearch}
        className='w-full py-2 my-2 px-2 border-2 rounded-l text-font11'
        placeholder={'Search'}
      />
      <div className="flex flex-wrap gap-1 items-center px-3 py-3">
        {Array.isArray(allData) &&
          allData.map((item) => {
            let icon = homeCity === item ? 'home' : ''
            let isWorkedOn = workedOnCitySet.has(item)
            let elementBgColor = isWorkedOn ? 'bg-scogoprimary' : 'bg-tagbg';
            let elementTextColor = isWorkedOn ? 'text-white' : '';
            return (
              <p key={item} className={`${elementBgColor} ${elementTextColor} scogoprimary 2xl:text-font11 text-font10 px-p-6 py-p-3 rounded-3px flex items-center mr-1 mb-1`}>
                {icon ?
                  <IconToolTip title="Home">
                    <span className='material-icons text-scogowhite m-auto text-font13 pr-2' >{icon}</span>
                  </IconToolTip>
                  : ''}
                {isWorkedOn ?
                  <IconToolTip title="worked on">
                    <div >{item}</div>
                  </IconToolTip>
                  : item}
              </p>
            );
          })}
      </div>
    </Box>
  </>

}



